import { Language } from './language';

const en = {
	code: Language.en,

	// HOME PAGE
	t_description: '{age} years old drummer girl',
	t_close: 'Close',

	b_home: 'Home',
	b_about: 'About Me',
	b_press: 'Press & Media',
	b_shows: 'Live Performances',
	b_latest_show: 'Latest',
	b_soultone: 'Soultone',
	b_paiste: 'Paiste',
	b_collision: 'Collision',
	b_language: 'English',
	b_share: 'Share',
	b_scroll_to_top: 'Scroll to top',
	b_click: 'Click',
	b_tap: 'Tap',

	t_english: 'English',
	t_spanish: 'Spanish',
	t_portuguese: 'Portuguese',
	t_italian: 'Italian',
	t_french: 'French',
	t_german: 'German',
	t_chinese: 'Chinese',

	// SHOWS PAGE

	KRKComeTogether2026DROM_title: 'KRFK Come Together Festival',
	KRKComeTogether2026DROM_description: 'DROM, New York City',

	KRKComeTogether2026Chelsea_title: 'KRFK Come Together Festival',
	KRKComeTogether2026Chelsea_description: 'Chelseea Table & Stage, New York City',

	RockFantasy2026Whisky_title: 'Rock n\' Roll Fantasy Camp',
	RockFantasy2026Whisky_description: 'The Whisky a Go Go, Hollywood CA.',

	RockFantasy2026Viper_title: 'Rock n\' Roll Fantasy Camp',
	RockFantasy2026Viper_description: 'The Viper Room Hollywood CA.',

	FulcrumCelebrationOfLight2026_title: 'Fulcrum Celebration of Light',
	FulcrumCelebrationOfLight2026_description: 'Sheraton Grand Seattle',

	QueenTribute_title: 'Queen Tribute',
	QueenTribute_description: 'School of Rock Seattle',

	FremontFridays2025_title: 'Fremont Fridays 2025',
	FremontFridays2025_description: 'Fremont Fridays Seattle',

	DrumFantasyCamp2025_title: 'Drum Fantasy Camp 2025',
	DrumFantasyCamp2025_description: 'Drum Fantasy Camp Los Angeles',

	ClassicMetal_title: 'Classic Metal',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Grand Day 2024 Performance',
	StAlsGrandDay2024_description: 'St. Alphonsus Parish School Seattle',

	BlackViolinConcert_title: 'Black Violin Concert With The World Youth Orchestra',
	BlackViolinConcert_description: 'The Paramount Theatre',

	MexicanIndependenceDay2024_title: 'Mexican Independence Day Celebration With The Ballard Civic Orchestra',
	MexicanIndependenceDay2024_description: 'Town Hall Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Ballard Seafood Fest 2024',
	BallardSeaFoodFest2024_description: 'Ballard Seafood Fest',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',

	ModernMetal_title: 'Modern Metal',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Season Preview Winter 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Hair Metal',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: '2023 Talent Show',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Season Preview Spring 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'The Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Soundtrack Show',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: '90\'s Nostalgia',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: '2022 Talent Show',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',


	// PRESS PAGE

	b_watch_here: 'Watch here',

	king_5_feature_title: 'Fulcrum / King 5 Featuring',
	king_5_feature_description: 'Seattle King 5 TV feature sponsored by Fulcrum',

	bateristland_title: 'Bateristland Featuring',
	bateristland_description: 'Bateristland YouTube Channel Interview',
	
	komo_news_title: 'Komo News Featuring',
	komo_news_description: 'Seattle Refined Iterview',

	andrew_rooney_drums_title: 'Andrew Rooney Reaction',
	andrew_rooney_drums_description: 'Andrew Rooney reacts to Victoria\'s performance of Tom Sawyer by Rush',

	upper_lefters_interview_title: 'Upper Lefters Interview',
	upper_lefters_interview_description: 'Upper Lefters YouTube Channel Interview about Victoria\'s career and future plans',

	the_eagle_969_title: '96.9 The Eagle Classic Hits Radio Station',
	the_eagle_969_description: '96.9 The Eagle Classic Hits Blog Post about Victoria\'s Rush cover',

	fox_13_news_title: 'Fox 13 Seattle News Featuring',
	fox_13_news_description: 'True Northwest Section Featuring',

	the_daly_migs_show_interview_title: 'The Daly Migs Show Interview',
	the_daly_migs_show_interview_description: 'Interview About Getting invited to join Godsmack on Stage',

	alizee_defan_07_02_2024_title: '"Alizee Defan" Interview',
	alizee_defan_07_02_2024_description: 'Exclusive interview',

	jaime_mendez_news_06_26_2024_title: '"Jaime Mendez News" Interview',
	jaime_mendez_news_06_26_2024_description: 'Local Seattle News in spanish',
	
	bien_informado_03_22_2023_title: '"Bien Informado" Article',
	bien_informado_03_22_2023_description: 'Argentina News Website Article about Victoria Drums',

	wave_potter_reaction_01_30_2023_title: 'Wave Potter Reaction',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reacts to Victoria\'s cover of Lux Æterna by Metallica',

	// ABOUT PAGE

	b_back: 'Go Back',
	
	t_title: 'Victoria Acosta',
	t_pronouns: '(she/her)',

	b_read_more: 'Read more',
	b_read_less: 'Read less',
	b_stat_age: 'Age',
	b_stat_shows: 'Live Shows',
	b_stat_yrs: 'Yrs Drumming',
	b_stat_awards: 'Awards',

	t_about: `
With sticks in hand and rhythm in her soul, {age}-year-old Victoria Acosta is one of the most exciting young drummers to watch. Born in El Paso, Texas, raised in Guadalajara, Mexico, and now based in Seattle, she is known for her dedication, energy, and commanding stage presence.

Victoria began drumming at four and received her first kit on September 13, 2018. She trained at Musicalerias Academy in Guadalajara before continuing her studies in Seattle. After a trial lesson at School of Rock on May 29, 2022, she skipped Rock 101 and entered the Performers Program, going on to perform in {shows} live shows.

She has recorded hundreds of social media videos and, on June 13, 2024, was invited by Italian composer Alberto Rigonni as a guest drummer for Nemesis Call. She received a Soultone Cymbals endorsement on September 12, 2024, and joined the Collision Drumsticks artist roster on March 8, 2025.

In August 2025, Victoria attended Drum Fantasy Camp in Los Angeles, studying with Dave Weckl, Dennis Chambers, Peter Erskine, and Gavin Harrison. That month, she also began studying with drum educator Dave Stark, whose guidance continues to shape her technique, musicianship, and artistic voice.

On February 13, 2026, Victoria became a Paiste Artist. That month, she also joined Rock and Roll Fantasy Camp, jamming with Nita Strauss, Stewart Copeland, Monte Pittman, Steve Stevens, Skunk Baxter, and Leland Sklar, and performing at Hollywood’s Viper Room and Whisky a Go Go. In 2026, she won the Neil Peart Drum Set Scholarship, given by the Percussive Arts Society and Hudson.

Beyond drums, Victoria began violin in 4th grade and joined the World Youth Orchestra in 2024. She performed with Black Violin at the Paramount Theatre and debuted as a percussionist with the Ballard Civic Orchestra at Town Hall Seattle for a Mexican Independence Day celebration.

Her awards include the Gold Prize and Fantastic Technique Award from the London Young Musician Contest 2022, plus the Annual Star Musician and Outstanding Drummer Special Awards in 2023. Victoria practices daily, pushing her limits with unstoppable drive and boundless creativity.
`,

	// PRESS PAGE

	t_footer: 'All rights reserved',

	// SOULTONE: 

	b_visit_artist_page: 'Visit My Artist Page',

}

export default en;
